import dynamic from 'next/dynamic';
import React from 'react';
const WhoCanUsePage = dynamic(() => import('@/components/WhoCanUse'), {
  ssr: false,
});

const WhoCanUse = () => {
  return <WhoCanUsePage />;
};

export default WhoCanUse;
